import { Establecimientos } from './features/establecimientos/list/establecimientos-list.component';
import { Routes } from '@angular/router';
import { Titulos } from './features/titulos/list/titulos-list.component';
import { TitulosCreateComponent } from './features/titulos/create/create';
import { TitulosEditComponent } from './features/titulos/edit/edit.component';
import { TitulosViewComponent } from './features/titulos/view/titulos-view.component';
import { CompetenciasList } from './features/competencias/list/competencias-list.component';
import { Materias } from './features/materias/list/materias-list.component';
import { Planes } from './features/planes/planes.component';
import { PlanesEditComponent } from './features/planes/edit/edit.component';
import { PlanesViewComponent } from './features/planes/view/planes-view.component';
import { Modalidades } from './features/modalidades/modalidades.component';
import { Home } from './features/home/home.component';
import { AuthGuard } from './auth.guard';
// import { authGuard } from './auth.guard';
import { CompetenciasCreate } from './features/competencias/create/competencia-create.component';
import { TituloCompetenciasComponent } from './features/titulos/competencias/competencias.component';
import { PorTituloComponent } from './features/competencias/por-titulo/por-titulo.component';
import { PorDniComponent } from './features/competencias/por-dni/por-dni.component';
import { tokenGuard } from './token.guard';
import { MateriasPorPlanComponent } from './features/planes/materias/materias-por-plan.component';
import { MateriasCreateComponent } from './features/materias/create/materias-create.component';
import { MateriasEditComponent } from './features/materias/edit/materias-edit.component';
import { MateriasViewComponent } from './features/materias/view/materias-view.component';
import { PlanesCreateComponent } from './features/planes/create/planes-create.component';
import { EstablecimientosViewComponent } from './features/establecimientos/view/establecimientos-view.component';
import { EstablecimientosCreateComponent } from './features/establecimientos/create/establecimientos-create.component';
import { EstablecimientosEditComponent } from './features/establecimientos/edit/establecimientos-edit.component';
import { AsignarAPersonaComponent } from './features/titulos/asignar-a-persona/asignar-a-persona.component';

export const routes: Routes = [
  { path: '', component: Home ,canActivate: [tokenGuard]},
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: 'titulos', component: Titulos },
      { path: 'titulos/create', component: TitulosCreateComponent },
      { path: 'titulos/:id/edit', component: TitulosEditComponent },
      { path: 'titulos/:id/view', component: TitulosViewComponent },
      { path: 'titulos/:id/competencias', component: TituloCompetenciasComponent },
      { path: 'titulos/por-dni', component: PorDniComponent },
      { path: 'titulos/asignar', component: AsignarAPersonaComponent },
      { path: 'competencias', component: CompetenciasList },
      { path: 'competencias/create', component: CompetenciasCreate },
      { path: 'competencias/:id/edit', component: TitulosEditComponent },
      { path: 'competencias/:id/view', component: TitulosViewComponent },
      { path: 'competencias/por-titulo', component: PorTituloComponent },
      { path: 'competencias/por-dni', component: PorDniComponent },
      { path: 'materias', component: Materias },
      { path: 'materias/create', component: MateriasCreateComponent },
      { path: 'materias/:id/edit', component: MateriasEditComponent },
      { path: 'materias/:id/view', component: MateriasViewComponent },
      { path: 'planes', component: Planes },
      { path: 'planes/create', component: PlanesCreateComponent },
      { path: 'planes/:id/edit', component: PlanesEditComponent },
      { path: 'planes/:id/view', component: PlanesViewComponent },
      { path: 'planes/:id/materias', component: MateriasPorPlanComponent },
      { path: 'modalidades', component: Modalidades },
      { path: 'establecimientos', component: Establecimientos },
      { path: 'establecimientos/create', component: EstablecimientosCreateComponent },
      { path: 'establecimientos/:id/edit', component: EstablecimientosEditComponent },
      { path: 'establecimientos/:id/view', component: EstablecimientosViewComponent }
    ]
  }
];
